import { captureException } from '@sentry/browser'

import { Platform } from '@angular/cdk/platform'
import { ErrorHandler, Injectable } from '@angular/core'

import { DateService } from '@lemon/core/service/date.service'
import { LemonTranslationService } from '../service/lemon-translation.service'
import { LemonDateAdapter } from './LemonDateAdapter'

@Injectable()
export class LemonKuukausiDateAdapter extends LemonDateAdapter {
  constructor(errorHandler: ErrorHandler, dateService: DateService, platform: Platform, translationService: LemonTranslationService) {
    super(errorHandler, dateService, platform, translationService)
  }

  parse(value: any): Date | null {
    if (this.isDateInstance(value)) {
      return new Date(value)
    }

    try {
      return this.dateService.parsiKuukausi(value, this.translationService.nykyinenKieli)
    } catch (error) {
      captureException(error)
      return new Date('thisisinvaliddateithink')
    }
  }

  format(date: Date, displayFormat: Object): string {
    return this.dateService.muotoileKuukausiJaVuosi(date, this.translationService.nykyinenKieli)
  }
}
